export enum ParamDecoratorType {
    Body = 'BODY',
    Path = 'PATH',
    Query = 'QUERY',
    Header = 'HEADER'
}
